import Vue from 'vue'
import VueResource from 'vue-resource'
import mixins from '../mixins.js'
import toastr from '../toastr'
import DcForm from '../../component/dccore-form/dcForm.vue'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import Multiselect from '../../component/dccore-form/multiselect.vue'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import TextInput from '../../component/dccore-form/textInput.vue'
import NumberInput from '../../component/dccore-form/numberInput.vue'
import Checkbox from '../../component/dccore-form/checkbox.vue'

if ($('#basket_form').length) {
  Vue.use(VueResource)
  new Vue({
    el: '#basket_form',
    components: {
      RingLoader,
      DcForm,
      Multiselect,
      TextInput,
      Checkbox,
      NumberInput,
      Singleselect
    },
    mixins: [mixins],
    data: {
      saveBtnActive: true,
      addBasketMealBtnActive: false,
      basketId : null,
      loading: 0,
      brands: [],
      variants: [],
      mealTypes: [],
      sizes: [],
      basketMeal: {
        mealType: null,
        size: null
      },
      basket: {
        id: null,
        name: null,
        basketMeals: [],
        variants: [],
        active: true
      },
      form: {
        options: {
          errors: {
            basketMeals: [],
          },
        }
      },
    },
    watch: {
      'basketMeal.mealType': function () {
        this.validate()
      },
      'basketMeal.size': function () {
        this.validate()
      }
    },
    mounted: function () {
      this.getBrands()
      this.getMealTypes()
      this.getSizes()

      if ($('#entity_id').length) {
        this.basketId = $('#entity_id').val()
        this.getBasket()
      }
    },
    methods: {
      validate: function() {
        this.addBasketMealBtnActive = this.basketMeal.size && this.basketMeal.mealType
        this.saveBtnActive = this.addBasketMealBtnActive || (this.basketMeal.size === null && this.basketMeal.mealType === null)
      },
      preSave: function() {
        if (this.addBasketMealBtnActive) {
          this.addBasketMeal()
        }
      },
      createBasket: function (redirect) {
        this.preSave()

        //this.buttonSave.button('loading');
        var url = Routing.generate('api_post_basket')

        Vue.http.post(url, {
          'data': this.basket
        }).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('basket_grid'))
          } else {
            this.form.options.errors = {}
            toastr.success(Translator.trans('basket.create.created'))
          }
        }, response => {
          this.handleAjaxError(response, this.form.options)
        })
      },
      updateBasket: function (redirect) {
        this.preSave()

        var url = Routing.generate('api_patch_basket', { id: this.basketId })

        Vue.http.patch(url, {
          'data': this.basket,
        }).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('basket_grid'))
          } else {
            this.form.options.errors = {}
            toastr.success(Translator.trans('basket.update.updated'))
          }
        }, response => {
          this.handleAjaxError(response, this.form.options)
        })
      },
      getBasket: function () {
        this.loading++

        var url = Routing.generate('api_get_basket', { id: this.basketId,
          context: 'edit' })

        Vue.http.get(url).then(response => {
          this.basket = response.data
          this.getVariants(this.basket.brand)
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getBrands() {
        this.loading++
        let url = Routing.generate('api_get_brands', { context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.brands = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getVariants(brandId) {
        let url = Routing.generate('api_get_variants_for_brand', {
          brand: brandId,
          context: 'list'
        })

        this.$http.get(url).then(response => {
          this.variants = response.data
        }, response => {
          this.handleAjaxError(response)
        })
      },
      getMealTypes() {
        let url = Routing.generate('api_get_meal_types', { context: 'dropdown' })
        this.loading++
        this.$http.get(url).then(response => {
          this.mealTypes = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getSizes() {
        let url = Routing.generate('api_get_sizes', { context: 'dropdown' })
        this.loading++
        this.$http.get(url).then(response => {
          this.sizes = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      hideBasketMealForm() {
        // clear basketMeal object on hide
        this.basketMeal.mealType = null
        this.basketMeal.size = null
      },
      addBasketMeal() {
        this.basket.basketMeals.push(Vue.util.extend({}, this.basketMeal))
        this.hideBasketMealForm()
      },
      removeBasketMeal(basketMeal) {
        let index = this.basket.basketMeals.indexOf(basketMeal)
        this.basket.basketMeals.splice(index, 1)
      },
      basketMealError: function (key) {
        let hasError = this.form.options.errors.basketMeals && this.form.options.errors.basketMeals[key]

        return hasError ? this.form.options.errors.basketMeals[key] : {}
      }
    }
  })
}
